<template>
  <div class="mainBody">
    <div class="mainCtn">
      <div class="topCtn">
        <div class="label">
          <img src="../../assets/rsTool/任务创建人图标.png" height="20" width="20" style="display: inline-block;margin-right: 1px;margin-top: -3px;" />
          我是任务创建人
        </div>
        <div class="progressAxis">
          <div class="dotBlue">
            <div class="txt">
              选择项目
            </div>
          </div>
          <div :class="step>=2?'lineBlue':'line'"></div>
          <div :class="step>=2?'dotBlue':'dot'">
            <div class="txt">
              选择团队
            </div>
          </div>
          <div :class="step>=3?'lineBlue':'line'"></div>
          <div :class="step>=3?'dotBlue':'dot'">
            <div class="txt">
              创建任务
            </div>
          </div>
          <div :class="step>=4?'lineBlue':'line'"></div>
          <div :class="step>=4?'dotBlue':'dot'">
            <div class="txt">
              分配人员
            </div>
          </div>

        </div>
      </div>
      <!--选择项目-->
      <div v-if="step==1"  class="signUp_content">
        <div class="componentCtn-main">
          <div class="projectCtn"
               title="创建项目"
               @click="createProjectModal=true;showVectoryCheckLoading=false;CascaderSelectId++"
               style="background: #D8D8D8;border:none;display: flex;justify-content: center;align-items: center;cursor:pointer;"
          >
              <img src="../../assets/userCenter/我的项目-增加按钮.png"  height="93" width="93"/>
          </div>
          <span v-for="item in projectList" :key="item.id">
            <div  :class="{'projectCtn':true,'selectedProject':item.id==projectAndTask.selectedProject}">
              <div class="topCtn">
                <div class="contentMask">

                  <div class="contentItem">
                    项目状态:<span v-if="item.delete_status==0&&item.end_time>getTodayTime()&&item.start_time<getTodayTime()">进行中</span><span
                      v-if="item.delete_status==1" style="color:red;">已终止</span><span v-if="item.delete_status==0&&item.end_time<getTodayTime()" style="color:red;">已过期</span><span v-if="item.delete_status==0&&item.start_time>getTodayTime()" style="color:red;">尚未到期</span>
                  </div>
                  <div class="contentItem">
                    有效期:{{ item.start_time.split(" ")[0] }}-{{ item.end_time.split(" ")[0] }}
                  </div>
                  <div class="contentItem" style="display:flex;justify-content:center;text-align: center;height:auto;margin-top: 20px;">
                    <!--仅创建者和队长可以进入团队-->
                    <span v-if="item.group_created_user_id==item.member_user_id||item.role=='1'">
                     <a-button @click="clickProject(item.id,item)" type="primary" style="font-size: 12px"
                               :disabled="item.delete_status!=0">选择项目</a-button>
                      <a-button @click="clickEditProject(item)" type="gray" style="font-size: 12px;margin-left: 20px;"
                                :disabled="item.delete_status!=0">查看项目</a-button>
                  </span>
                    <span v-else>
                    <a-button @click="$message.error('仅创建者或队长可以进入')" type="primary" style="font-size: 12px"
                              :disabled="item.delete_status!=0">选择项目</a-button>
                  </span>
                  </div>
                </div>
                <!--标识-->
                <a-tag v-if="item.group_created_user_id==item.member_user_id"
                       style="position:absolute;top:9px;right: 3px;" color="green">
                  创建者
                </a-tag>
                <!--标识-->
                <a-tag v-else-if="item.role=='1'" style="position:absolute;top:9px;right: 3px;" color="blue">
                  队长
                </a-tag>
                <!--标识-->
                <a-tag v-else style="position:absolute;top:9px;right: 3px;" color="gray">
                  普通队员
                </a-tag>
              </div>
              <div :title="item.name" class="middleCtn">
                {{ item.name }}
              </div>
            </div>
          </span>
        </div>
      </div>
      <!--选择项目下一步-->
      <div v-if="step==1" class="bottomCtn">
        <div v-if="!projectAndTask.selectedProject" class="btn_gray">
          下一步
        </div>
        <div v-if="projectAndTask.selectedProject" @click="step=2" class="btn_blue">
          下一步
        </div>

      </div>
      <!--选择团队-->
      <div v-if="step==2" class="signUp_content">
        <div v-if="teamList.length>0" class="componentCtn-main">
          <!--团队列表-->
          <span v-for="item in teamList" :key="item.id">
            <div :class="{'projectCtn':true,'selectedProject':item.id==selectedTeamId}">
              <div class="topCtn-team">
                <div class="contentMask">
                  <div class="contentItem" style="display:flex;justify-content: center;height:auto;margin-top: 20px;">
                    <!--仅创建者和队长可以进入团队-->
                    <span>
                       <a-button @click="clickTeam(item.id,item)" type="primary" style="font-size: 12px">
                         选择团队
                       </a-button>
                      <a-button @click="getMembersList(item.id,item)" type="gray" style="font-size: 12px;margin-left: 20px;">
                         查看团队
                       </a-button>
                    </span>
                  </div>
                </div>
                <!--标识-->
                <a-tag v-if="item.groupRoleType=='创建人'"
                       style="position:absolute;top:9px;right: 3px;" color="green">
                  创建者
                </a-tag>
                <!--标识-->
                <a-tag v-else-if="item.groupRoleType=='队长'" style="position:absolute;top:9px;right: 3px;" color="blue">
                  队长
                </a-tag>
                <!--标识-->
                <a-tag v-else-if="item.groupRoleType=='队员'" style="position:absolute;top:9px;right: 3px;" color="gray">
                  普通队员
                </a-tag>
              </div>
              <div class="middleCtn" :title="item.name">
                {{item.name}}
              </div>
            </div>
          </span>

        </div>
        <div v-else class="componentCtn-main2">
          <div class="tipCtn">
            <img src="../../assets/rsTool/提示.png" height="44" width="44" style="display: block;margin-top: 150px;"/>
            <div class="tip1">
              温馨提示
            </div>
            <div class="tip2">
              你尚未创建团队，<a @click="$router.push('/userCenter?type=3')" style="color:#006699;border-bottom: solid 1px #006699">点击创建团队</a>
            </div>
          </div>
        </div>
      </div>
      <!--选择团队下一步-->
      <div v-if="step==2" class="bottomCtn">
        <div @click="step=1" class="btn_blue" style="margin-right: 30px;">
          上一步
        </div>
        <div v-if="!selectedTeamId" class="btn_gray">
          下一步
        </div>
        <div v-if="selectedTeamId" @click="step=3;add(projectAndTask.selectedProject)" class="btn_blue">
          下一步
        </div>
      </div>
      <!--创建任务-->
      <div v-if="step==3" class="signUp_content" >
          <div class="rw_line" style="margin-top: 50px;">
            <div class="rw_txt">
              <span style="color:#E02020">*</span> 任务名称
            </div>
            <div class="rw_input" style="width: 500px;">
              <a-input v-model="wyhc.name" size="large" style="height: 40px;font-size: 14px;" placeholder="请填写任务名称"/>
            </div>
          </div>
        <div class="rw_line" style="margin-top: 30px;">
          <div class="rw_txt">
            <span style="color:#E02020">*</span> 任务描述
          </div>
          <div class="rw_input" >
            <a-textarea v-model="wyhc.desp"
                        size="large" style="height: 60px;font-size: 14px" placeholder="请填写任务描述"/>
          </div>
        </div>
        <div class="rw_line" style="margin-top: 30px;">
          <div class="rw_txt">
            <span style="color:#E02020">*</span> 上传文件
          </div>
        </div>
        <div class="rw_line" >
          <div class="rw_input" style="width: 1200px;height:200px;">
            <a-upload-dragger
                :fileList="fileList"
                name="file"
                accept=".zip,.ZIP"
                @change="handleFileChange_wyhc"
                :multiple="false"
                :showUploadList="true"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" style="color:#a4a4a4" />
              </p>

              <p class="ant-upload-hint" style="color:#a4a4a4;">
                上传文件必须是zip格式，坐标采用WGS1984，字符编码采用UTF-8,文件大小不超过5M
              </p>
            </a-upload-dragger>
            <div v-if="this.wyhc.importShapeFile" style="width: 100%;height:30px;line-height: 30px;font-size: 12px;padding-left: 10px;color:#0160be">
              已选择文件：{{this.wyhc.importShapeFile.name}}
            </div>
          </div>
        </div>
        <div class="rw_line" style="margin-top: 30px;">
          <div @click="downloadPDF" class="downloadButton">
            <img src="../../assets/rsTool/下载.png" height="13" width="10" />
            下载上传文件规则
          </div>
        </div>
      </div>
      <!--创建任务下一步-->
      <div v-if="step==3" class="bottomCtn">
        <div @click="step=2" class="btn_blue" style="margin-right: 30px;">
          上一步
        </div>
        <div @click="clickCreateTask"  class="btn_blue">
          创建任务
        </div>
      </div>
      <!--分配人员-->
      <div v-if="step==4" class="signUp_content" style="height:600px;">
        <div class="assignEmployeesCtn" style="height:300px;">
          <wyMarkerModal ref="markerModalForm"></wyMarkerModal>
        </div>
        <div class="assignEmployeesCtn" style="height:300px;">
          <wyShenhe-modal ref="shenheModalForm"></wyShenhe-modal>
        </div>
      </div>
      <!--分配人员下一步-->
      <div v-if="step==4" class="bottomCtn">
        <div  class="btn_blue" @click="assignEmployeesComplete">
          完成
        </div>
      </div>
      <!--完成任务创建-->
      <div v-if="step==5" class="signUp_content" style="display:flex;flex-direction:column;
      align-items:center;background: #ffffff;border-radius: 5px;height:400px;margin-left: 200px;margin-top: 100px;">
        <div style="margin-top: 100px;">
          <img src="../../assets/rsStandard/成功.png" height="44" width="44" />
        </div>
        <div class="txt2" style="margin-top: 30px;">
          恭喜！您已成功创建任务
        </div>
        <div class="btn2" style="margin-top: 62px;" @click="$router.push({path: 'userCenter', query: {'type': 1}})">
          进入工作台
        </div>

      </div>


    </div>

    <!--团队详情-->
    <a-modal
        title="团队详情"
        :width="800"
        :visible="group_Detail"
        :footer="null"
        :mask='false'
        :maskClosable='false'
        @cancel="group_Detail=false"
        style="padding-top: 100px;"
        cancelText="关闭">
      <a-card :bordered="false" :body-style="{padding: 0}">
        <detail-list>
          <detail-list-item term="团队名称" style="width:100%;">
            {{checkGroupName}}
          </detail-list-item>
          <detail-list-item term="团队成员" style="width:100%;">
            <a-tag color="red" v-for="(item,index) in groupDetailMembers" :key="index">{{ item.name }}</a-tag>
          </detail-list-item>
        </detail-list>
      </a-card>
    </a-modal>
    <!--创建团队对话框-->
    <a-modal v-model="createTeamModal"
             centered
             width="667">
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          创建团队
        </div>
      </template>
      <div style="width:667px;height:auto;min-height:100px;">
        <div class="createProjectLine">
          <div class="item-name">
            团队名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="createTeamName" size="large" style="height: 40px;font-size: 14px;" placeholder="请填写团队名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            队长
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input" style="width:400px">
            <a-input-search size="large" style="height: 40px;font-size: 14px;" placeholder="请输入队长ID或电话查询" enter-button @search="searchUser"/>
          </div>
          <div class="item-input" style="width:200px;line-height: 40px;padding-left: 17px;">
            <a-radio-group v-model="teamleaderSearchType" buttonStyle="solid">
              <a-radio-button value="phone">
                电话查询
              </a-radio-button>
              <a-radio-button value="id">
                ID查询
              </a-radio-button>
            </a-radio-group>
          </div>

        </div>
        <div v-if="teamLeaderInfo" class="createProjectLine" >
          <div class="item-name">
            队长信息
          </div>
          <div  class="item-input" style="line-height: 40px;border:solid 1px #dcdcdc;border-radius: 5px;padding-left: 12px;">
            {{teamLeaderInfo}}
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button @click="createTeam()" type="primary">
          创建
        </a-button>
        <a-button @click="createProjectModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--创建项目对话框-->
    <a-modal v-model="createProjectModal"
             centered
             width="667">
      <div style="width:667px;height:auto;min-height:500px;">
        <div class="createProjectLine">
          <div class="item-name">
            项目名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="addProjectData.name"
                     size="large" style="height: 40px;font-size: 14px;" placeholder="请填写项目名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            项目描述
          </div>
          <div class="item-input">
            <a-textarea v-model="addProjectData.description"
                        size="large" style="height: 60px;font-size: 14px" placeholder="请填写项目描述"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            项目有效期
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-range-picker
                :placeholder="['开始日期','结束日期']"
                size="large"
                :locale="locale"
                style="height:40px;width: 560px;font-size: 14px;"
                :disabled-date="disabledDate"
                v-model="tempTime"
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD">
            </a-range-picker>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择套件
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <CascaderSelect
                :key="'CascaderSelect'+CascaderSelectId"
                allowClear
                style="width:100%;height:40px"
                :maxTagCount="3"
                :maxTagTextLength="4"
                placeholder="请选择"
                :selectOptionsConfig="{
                    key: 'id',
                    value: 'id',
                    text: 'name',
                    children: 'mkList'
                    }"
                noDataText="暂无数据"
                :treeData="[multipleTreeData]"
                @handleCheckboxChange="handleCheckboxChange"
            />
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择矢量
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="在矢量库中选择" >
                <div class="vectorPanel">
                  <a-checkbox-group v-model="addProjectData.shape_ids" style="width: 100%">
                    <div v-for="item in vectorList" :key="item.id" class="itemCtn">
                      <a-checkbox style="color:#000000" :value="item.id" :disabled="Number(item.nrings)>15">
                        {{ item.name }}
                      </a-checkbox>
                      <a-tag color="blue" style="float:right;margin-top: 5px;cursor: pointer" @click="checkAndShow(item.id)">
                        查看
                      </a-tag>
                    </div>
                  </a-checkbox-group>
                </div>
              </a-tab-pane>

            </a-tabs>
          </div>
        </div>


      </div>
      <template slot="footer">
        <a-button type="primary" @click="clickCreateProject">
          创建
        </a-button>
        <a-button @click="createProjectModal=false">
          取消
        </a-button>
      </template>
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          创建项目
        </div>
      </template>
    </a-modal>
    <!--确认创建项目对话框-->
    <a-modal v-model="confirmCreateProjectModal"
             centered
             width="490"
    >
      <div
          style="display:flex;justify-content:left;width:490px;min-height:60px;height:auto;padding-bottom:10px;margin-top: 20px;">
        <div style="width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <!--        <div-->
        <!--            style="width: calc(100% - 63px);min-height:63px;line-height: 31px;height:auto;padding-left: 20px;font-size:20px;font-weight: 600;">-->
        <!--          当前套件的剩余面积额度<span style="color:#E02020;">7万km<sup>2</sup></span><br/>-->
        <!--          创建后只可增加不可删除，请谨慎选择。 <br/>-->
        <!--          确定创建项目 遥感开发者在线标注项目 ?-->
        <!--        </div>-->
        <div class="shareListCtn">
            <span v-for="item in repositoryRemainlist" :key="item.repository_id">
              <span v-if="item.repository_name!='体验版'">
                 当前套件“{{item.repository_name}}”的剩余面积额度为<span style="color:#E02020;">{{(item.curRemainArea).toFixed(2)}}km<sup>2</sup></span>;<br/>
              </span>
            </span>
          <span v-for="item in vectorBufferedList" :key="item.id">
              <span v-if="item.new_area">矢量“{{item.shape_name}}”中有要素面积不足25平方公里，将自动扩充，详情请点击查看按钮;<br/></span>
            </span>
          创建后只可增加不可删除，请谨慎选择。确定创建项目: {{addProjectData.name}}?
        </div>

      </div>
      <template slot="footer">
        <a-button @click="confirmCreateProject()" type="danger">
          确定
        </a-button>
        <a-button @click="confirmCreateProjectModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--编辑项目对话框-->
    <a-modal v-model="editProjectModal"
             centered
             width="667">
      <template slot="title" style="border:none;">
        <div
            style="height:40px;line-height: 40px;font-size: 20px;font-weight: 700;border-left:5px solid #0091ff;padding-left: 15px;">
          查看项目
        </div>
      </template>
      <div style="width:667px;height:auto;min-height:500px;">
        <div class="createProjectLine">
          <div class="item-name">
            项目名称
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-input v-model="editProjectData.name" disabled
                     size="large" style="height: 40px;font-size: 14px;" placeholder="请填写项目名称"/>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            项目描述
          </div>
          <div class="item-input">
            <a-textarea v-model="editProjectData.description" disabled
                        size="large" style="height: 60px;font-size: 14px" placeholder="请填写项目描述"/>
          </div>
        </div>
        <!-- <div class="createProjectLine">
          <div class="item-name">
            项目团队
          </div>
          <div class="item-input">
            <a-select v-model="editProjectData.group_id" disabled
                      size="large" style="height:40px;width: 560px;font-size: 14px;"
                      placeholder="请选择要添加的项目成员">
              <a-select-option v-for="item in teamList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div> -->
        <div class="createProjectLine">
          <div class="item-name">
            项目有效期
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-range-picker
                :placeholder="['开始日期','结束日期']"
                size="large"
                :locale="locale"
                style="height:40px;width: 560px;font-size: 14px;"
                :disabled-date="disabledDate"
                v-model="tempTime_edit"
                format="YYYY-MM-DD"
                disabled
                valueFormat="YYYY-MM-DD">

            </a-range-picker>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择套件
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <div class="edit-tj-ctn">
              <div v-for="item in editProjectData.edit_repository" :key="item.id" class="item-ctn">
                <div class="tj-title">
                  {{item.name}}:
                </div>
                <div class="mk-ctn">
                  <div v-for="mk_item in item.mks" :key="mk_item.id" class="mk-item">
                    {{mk_item.name}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="createProjectLine">
          <div class="item-name">
            选择矢量
            <img src="../../assets/userCenter/必填标志.png"
                 style="position:absolute;top:8px;left:-9px;width: 8px;height: 8px;"/>
          </div>
          <div class="item-input">
            <a-tabs default-active-key="1" >
              <a-tab-pane key="1" tab="在矢量库中选择" disabled>
                <div class="vectorPanel" style="height:100px;">
                  <!--                  <div style="width:100%;height: 100px;line-height: 100px;text-align: center">-->
                  <!--                    已选矢量不可更改-->
                  <!--                  </div>-->
                  <a-checkbox-group  style="width: 100%">
                    <div v-for="item in editProjectData.shapes" :key="item.id" class="itemCtn">
                      <a-checkbox style="color:#000000" :value="item.id" disabled>
                        {{ item.name }}
                      </a-checkbox>
                      <a-tag color="blue" style="float:right;margin-top: 5px;cursor: pointer" @click="checkAndShow(item.id)">
                        查看
                      </a-tag>
                    </div>
                  </a-checkbox-group>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="上传矢量" disabled>
                Content of Tab Pane 2
              </a-tab-pane>
              <a-tab-pane key="3" tab="勾画矢量" disabled>
                Content of Tab Pane 3
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>


      </div>
      <template slot="footer">
        <a-button type="primary" @click="clickConfirmEditProject">
          确认
        </a-button>
        <a-button @click="createProjectModal=false">
          取消
        </a-button>
      </template>

    </a-modal>
    <!--矢量与套件无相交-->
    <a-modal v-model="noIntersectModal"
             centered
             width="490"
    >
      <div
          style="display:flex;justify-content:left;width:490px;min-height:60px;height:auto;padding-bottom:10px;margin-top: 20px;">
        <div style="width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <!--        <div-->
        <!--            style="width: calc(100% - 63px);min-height:63px;line-height: 31px;height:auto;padding-left: 20px;font-size:20px;font-weight: 600;">-->
        <!--          当前套件的剩余面积额度<span style="color:#E02020;">7万km<sup>2</sup></span><br/>-->
        <!--          创建后只可增加不可删除，请谨慎选择。 <br/>-->
        <!--          确定创建项目 遥感开发者在线标注项目 ?-->
        <!--        </div>-->
        <div v-if="noIntersectResponse.intersectShapes.length>0"  class="shareListCtn" style="line-height: 60px;">
          您选择的矢量列表中仅{{noIntersectResponse.intersectShapes}}与所选套件{{noIntersectResponse.intersectMks}}有相交区域，请去除多余矢量或套件后重新提交。
        </div>
        <div v-if="noIntersectResponse.intersectShapes.length==0&&noIntersectResponse.intersectMks.length==0"  class="shareListCtn" style="line-height: 60px;">
          您选择的套件和矢量无相交区域，请重新选择。
        </div>

      </div>
      <template slot="footer">
        <a-button @click="noIntersectModal=false">
          重新选择
        </a-button>
      </template>
    </a-modal>
    <!--查看矢量对话框-->
    <a-modal v-model="viewVectorModal"
             centered width="660px" :header="null"
             :footer="null"
    >
      <div class="overviewVectorDiv"  style="position:relative;z-index: 1000000;">
        <l-map
            :maxBounds="maxBounds"
            :minZoom="parseInt(2)"
            ref="map"
            style="width: 100%; height: 100%;z-index: 1000000;"
            :zoom="zoom"
            :center="center"
            :options="option"
            :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
        >
          <template mark="map">
            <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
            <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
          </template>
          <l-geo-json
              v-if="bufferGeo.geojson"
              :geojson="bufferGeo.geojson"
              :optionsStyle="bufferGeojsonStyle"
          ></l-geo-json>

          <l-geo-json
              v-if="overviewGeo.geojson"
              :geojson="overviewGeo.geojson"
              :optionsStyle="targetGeojsonStyle"
          ></l-geo-json>
        </l-map>
      </div>

    </a-modal>
    <!--地图弹窗-->
    <div class="text-center" v-if="mapdialog" style="z-index:1001">
      <v-dialog v-model="mapdialog" width="100vw" height="100vh" content-class="mapDialog">
        <v-card
            height="100vh"
            style="position: relative;width: calc(100vw - 8px);padding: 1px;z-index:1001;"
        >
          <!--关闭标签-->
          <img
              style="position: absolute; top: 25px;right:30px;z-index:1; cursor: pointer"
              src="~@/assets/RSsserviceManage/关闭.png"
              height="40"
              width="40"
              @click="mapdialog = false;juanlianOpen=false"
          />
          <!-- <div id="cgmapmk"></div> -->
          <div class="mapdiv">
            <pl-lazy>
              <main-map
                  ref="mainmap"
                  :lyrdata="lyrdata"
                  :mapCtrlTools="mapCtrlTools4Use"
                  :mapParams="mapParams"
              >
              </main-map>
            </pl-lazy>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-overlay :value="overlay" :z-index="10000">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
<!--    <div style='position:absolute;bottom:10px;right:10px;width: 300px;height:30px;'>-->
<!--      <div @click="step&#45;&#45;"-->
<!--           style='width: 125px;height:30px;border:solid 1px #ff0000;float: left;margin-right: 10px;'>-->
<!--        applyStep&#45;&#45;-->
<!--      </div>-->
<!--      <div @click="step++"-->
<!--           style='width: 125px;height:30px;border:solid 1px #ff0000;float: left;margin-right: 10px;'>-->
<!--        applyStep++-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
import moment from 'moment';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import DetailList from '@/components/tools/DetailList'
import CascaderSelect from '@/components/Cascader/Cascader.vue'
import L from 'leaflet'
import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
import 'leaflet-mouse-position'
import MainMap from '@/components/Maps/MainMap'
import wyMarkerModal from "@views/newProject/wyMarkerModal.vue";
import wyShenheModal from "@views/newProject/wyShenheModal.vue";



const DetailListItem = DetailList.Item
export default {
  name:'createProject',
  components: {
    wyMarkerModal,
    wyShenheModal,
    CascaderSelect,
    DetailList,
    DetailListItem,
    LMap,
    LTileLayer,
    LGeoJson,
    MainMap},
  data(){
    return{
      step:1,
      //外业核查
      wyhc:{
        name:null,
        desp:null,
        checkJl1UserIdList:[],
        verifyJl1UserIdList:[],
        programId:null,
        importShapeFile:null
      },
      fileList:[],
      //查看团队
      groupDetailMembers:[],
      group_Detail:false,
      checkGroupName:"",
      //创建团队
      createTeamModal: false,//创建项目
      tableData: [
      ],
      selectedTeamId:null,
      selectedList:['已加入','待确认','未加入'],
      satatusOptions:['已加入','待确认','未加入'],
      //以下创建团队字段
      memberInputSearch:'',
      teamleaderSearchType:'phone',
      teamLeaderInfo:"",
      createTeamName:"",
      createTeamLeaderId:"",
      //创建任务
      projectAndTask:{//选择任务与创建项目字段
        selectedProject:null,
        createdTask:null,
      },
      dataList:[],
      closeProjectModal:false,//关闭项目
      closeProjectId:'',//关闭项目id
      closeProjectName:'',
      shareLinkModal:false,//分享项目
      createProjectModal:false,//创建项目
      confirmCreateProjectModal:false,//确认创建项目
      editProjectModal:false,//编辑项目
      locale,//时间插件文字中文
      exhibitLevel:1,//展现层级
      repositoryExamplse: {
        "list": [{
          "id": "91870dad63384e5488f2f169f7a8f402",
          "mk_ids": ["315920d6259b45a985511c329d23ef50", "01238ef3fbb346d28f4446527b6102b4"]
        }]
      },
      groupId_currentProject:'',//当前项目groupId
      currentProject:{},
      projectList:[],//项目列表
      //以下是新增项目相关字段
      addProjectData:{
        name:'',
        start_time:'',
        end_time:'',
        description:'',
        shape_ids:[],//矢量库选择的矢量
        group_id:'',
        repository:{list:[]},//套件与选择的图层
        geojson:'',//上传矢量或勾画矢量
      },
      tempTime:[],//时间选择器
      vectorList:[],//矢量列表
      teamList:[],//团队列表
      repositoryMultipleTreeData:[],
      repositoryRemainlist:[],//套件使用情况
      vectorBufferedList:[],//矢量外扩情况
      showVectoryCheckLoading:false,//数据检验中
      noIntersectModal:false,//无相交
      noIntersectResponse:{
        intersectShapes:[],
        intersectMks:[]
      },
      CascaderSelectId:1,
      //以下是编辑项目字段
      editProjectData:{
        program_id:'',
        name:'',
        start_time:'',
        end_time:'',
        description:'',
        shape_ids:[],//矢量库选择的矢量
        group_id:'',
        repository:{},//套件与选择的图层
        geojson:'',//上传矢量或勾画矢量
      },
      tempTime_edit:[],
      editTree:[],
      //以下为任务字段
      selectType:1,//1：协同标注，2：标注审核；3.外业核查
      tableColumns:[
        {
          title: '任务名称',
          align: 'center',
          dataIndex: 'taskName'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'taskStatus',
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource:[],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        // pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        // showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      projectDetailDialog:false,//任务详情
      XTBZ_Stey:1,//协同标注步骤，1：列表，2：外接
      XTBZ_FullScreen:false,//协同标注-我的任务，全屏
      BZSH_FullScreen:false,//标注审核-我的任务，全屏
      projectId:'',
      confirmLoading: false,
      InputTaskName:'',
      InputTaskStatus:'',
      taskUsers:[],
      aduitUsers:[],
      taskImages:[],
      frameBaseUrl:'https://www.jl1mall.com/gisworkbench',
      frameUrl:this.frameBaseUrl + '/analysisTask/SampleLabelAudit',
      frameUrlOld:this.frameBaseUrl + '/analysisTask/SampleLabelAudit',
      multipleTreeData: [

      ],
      selectTaojian: [],
      // leaflet参数
      // targetModePoint: L.latLng(380, 90),
      targetMode: false,
      zoom: 4,
      center: L.latLng(33.978292, 105.395057),
      maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
      url: this.$store.state.mapUrl,
      subdomains: this.$store.state.mapSubdomains,
      option: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
      // showSearchRangeSelector: false,
      targetGeojsonStyle: {
        color: '#00BCD4',
        weight: 2,
        fillOpacity: 0
      },
      bufferGeojsonStyle: {
        color: '#F44336',
        fillColor: '#F44336',
        weight: 2,
        fillOpacity: 0.1
      },
      bufferGeo: {
        geojson: '',
        area:''
      },
      overviewGeo: {
        geojson: '',
        id:''
      },

      viewVectorModal: false,


      //地图
      mapdialog:false,
      tileBaseUrl:'https://api.jl1mall.com',
      lyrdata: [
        {
          lyrType:"Tile",
          srcType:"XYZ",
          mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=${this.tk}&vf=0`,
          mTitle:"全球一张图",
          mName:"全球一张图",
          mExtent:['73.5013','3.4065','135.0961','53.5632'],
          mVisible:true
        },
        {
          lyrType:"Tile",
          srcType:"XYZ",
          mUrl:"",
          mTitle:"",
          mName:"",
          mExtent:[],
          mVisible:true
        },
        // {
        //   lyrType: "MapboxVectorLayer",
        //   srcType: "MapboxVectorLayer",
        //   // mUrl: "https://earth.jl1.cn/symboltile/placetile",
        //   mTitle: "文字标注",
        //   mName: "文字标注",
        //   mVisible: true
        // }
      ],
      mapCtrlTools4Use: [2],
      mapParams: {
        projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
        center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
        // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
        // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
        minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
        maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
        zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
      },
      overlay: false,
    }
  },
  methods: {
    getTodayTime() {
      let dateTime = new Date();
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if(month< 10){ month="0" +month }
      let ri = dateTime.getDate();
      if(ri< 10){ ri="0" +ri }
      let hours = dateTime.getHours();
      if(hours< 10){ hours="0" +hours }
      let minutes=dateTime.getMinutes();
      if(minutes< 10){ minutes="0" +minutes }
      let seconds=dateTime.getSeconds();
      if (seconds < 10) { seconds = "0" + seconds }
      let time = year + "-" + month + "-" + ri + " " + hours + ":" + minutes + ":" + seconds
      return time;
    },
    //获取团队成员列表
    getMembersList:function (groupId,detail){
      this.checkGroupName=detail.name;
      let param=new FormData();
      param.append('JL1Account',"");
      param.append('name',"");
      param.append('status',"0,1,2");
      param.append('groupId',groupId);
      param.append('pageSize',100);
      param.append('pageNo',1);
      this.axios
          .post("/tilesapi/tiles/member/list", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取团队成员')
        console.log(response.data.data.records)
        this.groupDetailMembers=response.data.data.records;
        this.group_Detail=true;
      })
    },
    clickCreateTask:function () {
      if(!this.wyhc.name){
        this.$message.error("请输入任务名称");
        return;
      }
      if(!this.wyhc.desp){
        this.$message.error("请填写任务描述");
        return;
      }
      if(!this.wyhc.importShapeFile){
        this.$message.error("请上传矢量文件");
        return;
      }
      this.step=4;
      this.$nextTick(()=>{
        this.$refs.markerModalForm.show(this.selectedTeamId);
        this.$refs.shenheModalForm.show(this.selectedTeamId);
      })
    },
    downloadPDF:function () {
      let pdfURL = 'https://files.jl1mall.com/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C/%E5%A4%96%E4%B8%9A%E7%A7%BB%E5%8A%A8%E6%A0%B8%E6%9F%A5%E4%B8%8A%E4%BC%A0%E5%8E%8B%E7%BC%A9%E5%8C%85%E8%A7%84%E5%88%99.pdf';
      window.open(pdfURL)
    },
    //外业核查，文件上传
    handleFileChange_wyhc:function (data) {
      console.log("外业核查，文件上传")
      console.log(data)
      console.log(this.fileList)
      // this.fileList=data.fileList
      if(data.fileList.length>1){
        this.$message.error("一次最多上传一个文件")
        return;
      }
      if (data.file.originFileObj.size > 5 * 1024 * 1024) {
        this.$message.error("文件大小不能超过5MB")
        return;
      }
      this.wyhc.importShapeFile=data.file.originFileObj;
      console.log(this.wyhc.importShapeFile)
    },
    //查看项目详情
    //点击编辑项目
    clickEditProject: function (data) {
      this.editProjectData.program_id=data.id;
      this.editProjectData.name=data.name;
      this.editProjectData.description=data.description;
      this.editProjectData.group_id=data.group_id;
      this.tempTime_edit[0]=data.start_time;
      this.tempTime_edit[1]=data.end_time;
      this.editProjectData.shape_ids=data.shape_ids;
      this.editProjectData.repository=data.repository;
      this.editProjectData.geojson=data.geojson;
      this.editProjectData.shapes=data.shapes;//回显矢量
      this.editProjectData.edit_repository=data.repository_show.list;//回显套件
      this.editProjectModal = true;
    },
    //分配人员
    //点击标注人员按钮
    handleMarker(record) {
      console.log('标注人员ref')
      console.log(this.$refs.markerModalForm)
      console.log(record)
      this.$refs.markerModalForm.show(record.id, record.taskStatus, record.imageUrls, record.groupId);
    },
    //点击审核人员按钮
    handleShenhe(record) {
      console.log(record)
      this.$refs.shenheModalForm.show(record.id, record.taskStatus, record.imageUrls, record.groupId);
    },
    //创建团队
    //点击新建项目图表
    clickPlusIcon:function (){
      this.createTeamModal=true;
      this.teamLeaderInfo="";
      this.createTeamLeaderId="";
    },
    //查询团队列表（仅获取用户自己创建的）
    getTeamList: function () {
      this.axios.post("/tilesapi/tiles/group/queryUserCreateGroupList", null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        this.teamList = response.data.data;
        console.log("获取团队列表")
        console.log(this.teamList)
      })
    },
    //多选框改变
    selectChange:function (data){
      console.log(data)
      this.status=[];
      if(data.indexOf('待确认')>-1){
        console.log('待确认')
        this.status.push(0)
      }
      if(data.indexOf('已加入')>-1){
        this.status.push(1)
      }
      if(data.indexOf('未加入')>-1){
        this.status.push(2)
      }
      console.log(this.status)
      this.getMembersList();
    },
    //根据电话与ID查询用户
    searchUser:function (data){
      console.log(data)
      let param=new FormData();
      if(this.teamleaderSearchType=='id'){
        param.append('JL1Account',data);
        param.append('phone',"");
      }else if(this.teamleaderSearchType=='phone'){
        param.append('JL1Account',"");
        param.append('phone',data)
      }
      this.axios.post("/tilesapi/queryUserByPhoneAndAccount",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log(response)
        if(response.data.data){
          this.teamLeaderInfo=response.data.data.account;
          this.createTeamLeaderId=response.data.data.jl1Account;
        }
        else {
          this.$message.error("无此用户")
        }
      })
    },
    //点击团队
    clickTeam:function (id) {
      this.selectedTeamId=id;
    },
    //根据电话与ID查询用户，添加成员
    searchTeamer:function (data) {
      let param=new FormData();
      if(this.teamerSearchType=='id'){
        param.append('JL1Account',data);
        param.append('phone',"");
      }else if(this.teamerSearchType=='phone'){
        param.append('JL1Account',"");
        param.append('phone',data)
      }
      this.axios.post("/tilesapi/queryUserByPhoneAndAccount",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log(response)
        if(response.data.data){
          this.addteamerInfo=response.data.data.account;
          this.addTeamerId=response.data.data.jl1Account;
        }
        else {
          this.$message.error("无此用户")
        }
      })
    },
    //设为队长
    setTeamLeader:function (data) {
      console.log(data)
      let param=new FormData();
      param.append('groupId',this.recentTeamId)
      param.append('jl1UserId',data.jl1Account)
      this.axios.post("/tilesapi/tiles/member/editGroupUserRole",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log('设为队长')
        console.log(response)
        if(response.data.code==200){
          this.$message.success(response.data.msg)
        }
        if(response.data.code==500){
          this.$message.error(response.data.msg)
        }
        this.getMembersList();


      })

    },
    //创建团队
    createTeam:function () {
      if (!this.createTeamName) {
        this.$message.error("请输入团名");
        return;
      } else if (!this.createTeamLeaderId) {
        this.$message.error("请选择队长");
        return;
      }

      let param = {
        "name": this.createTeamName,
        "groupLeaderUserId": this.createTeamLeaderId,
      }
      this.axios.post("/tilesapi/tiles/group/addGroupWithMember",param, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        console.log(response)
        if(response.data.code==200){
          this.$message.success('创建成功!');
          this.createTeamModal=false;
          this.getTeamList();
        }
        else {
          this.$message.error(response.data.msg);
        }
      })
    },
    //*********创建项目##############
    clickCreateProject: function () {

      console.log('点击创建`项目')
      this.addProjectData.start_time=this.tempTime[0];
      this.addProjectData.end_time=this.tempTime[1];
      this.print(this.addProjectData);
      let param=this.addProjectData;
      console.log("this.addProjectData")
      console.log(this.addProjectData)
      if(!param.name){
        this.$message.error('请输入项目名')
        return;
      }
      else if(!param.start_time||!param.end_time){
        this.$message.error('请输入起止时间')
        return;
      }
      else if(param.repository.list.length==0){
        this.$message.error('请选择套件')
        return;
      }
      else if(param.shape_ids.length<1&&!param.geojson){
        this.$message.error('请选择矢量')
        return;
      }
      this.showVectoryCheckLoading=true;
      let reposityIds=[]
      for(let i=0;i<param.repository.list.length;i++){
        reposityIds.push(param.repository.list[i].id)
      }
      let param_form=new FormData();
      param_form.append('repository',JSON.stringify(this.addProjectData.repository));
      param_form.append('shape_ids',param.shape_ids.join(','));
      console.log('param_form')
      this.axios
          .post("/map_service_back/program/checkShpUseInReps", param_form,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        if(response.data.hasNotIntersect){
          console.log('无相交')
          console.log(response.data.data)
          this.noIntersectResponse=response.data.data;
          this.noIntersectModal=true;
          this.showVectoryCheckLoading=false;
        }else {
          console.log('查看套件使用情况')
          this.repositoryRemainlist=response.data.data;
          console.log(this.repositoryRemainlist);
          let remainList=this.repositoryRemainlist;
          this.showVectoryCheckLoading=false;
          for(let i=0;i<remainList.length;i++){
            if(remainList[i].preArea>100000&&remainList[i].repository_name!="体验版"){
              this.$message.error('套件：'+remainList[i].repository_name+'的使用面积已超过10万平方公里,无法继续使用，请重新选择套件。')
              return;
            }
          }
          this.$message.success('通过套件剩余量检查，可继续使用')
          //NOTE 校验矢量面积，自动扩充
          let formdata = new FormData();
          // let shapes = { list: [{ id: "xxx", shape: "xxx" ,"area": "xxx" ,name:"xxx",create_time:"xxx" }] }
          let shapes = { list: [] }

          for (let i = 0; i < this.vectorList.length; i++) {
            const vector = this.vectorList[i];
            for (let j = 0; j < param.shape_ids.length; j++) {
              const shape_id = param.shape_ids[j];
              if (vector.id==shape_id) {
                shapes.list.push({ id: vector.id, shape: vector.shape, area: vector.area,name:vector.name,create_time:vector.create_time })
              }
            }
          }

          formdata.append('shapes', JSON.stringify(shapes));
          this.axios.post("/map_service_back/program/checkGeomArea", formdata,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then(res => {
            if (res.data.code==200) {
              this.vectorBufferedList = res.data.data
            }
            this.confirmCreateProjectModal = true;
            this.showVectoryCheckLoading=false;
          })
        }

      })
    },
    confirmCreateProject: function () {
      let shapes = { list: [] }
      this.vectorBufferedList.forEach(v => {
        if (v.new_area) {
          shapes.list.push({ id: v.shape_id, shape: v.buffered_geom, area: v.new_area,name:v.shape_name,create_time:v.create_time })
        } else {
          shapes.list.push({ id: v.shape_id, shape: v.old_geom, area: v.old_area,name:v.shape_name,create_time:v.create_time })
        }
      })

      let data = this.addProjectData;
      let that = this;
      let param = new FormData();
      param.append('name', data.name);
      param.append('start_time', data.start_time);
      param.append('end_time', data.end_time);
      param.append('description', data.description);
      param.append('shapes', JSON.stringify(shapes));
      // param.append('shape_ids', data.shape_ids);
      param.append('group_id', data.group_id);
      // param.append('repository',data.repository);
      param.append('repository', JSON.stringify(data.repository));
      param.append('geojson', data.geojson);
      this.axios
          .post("/map_service_back/program/insertProgram", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('创建项目')
        console.log(response)
        if (response.data.code == 200) {
          this.$message.success(response.data.message)
          that.addProjectData = {
            name: '',
            start_time: '',
            end_time: '',
            description: '',
            shape_ids: '',//矢量库选择的矢量
            group_id: '',
            repository: {list:[]},//套件与选择的图层
            geojson: '',//上传矢量或勾画矢量
          }
          this.tempTime[0]="";
          this.tempTime[1]="";
          this.confirmCreateProjectModal = false;
          this.createProjectModal = false;
          this.getMyProjectList();
        } else {
          this.$message.error(response.data.message);
          this.confirmCreateProjectModal = false;
        }

      })

    },
    //日历表不可选择的日期
    disabledDate(current) {
      console.log("时间日期选择器")
      console.log(current)
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'day').endOf('day');
    },
    //获取我的项目
    getMyProjectList: function () {
      let that = this
      let param = new FormData();
      param.append('pageNum', 1);
      param.append('pageSize', 1000);

      this.axios
          .post("/map_service_back/program/getProgramList", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取我的项目列表')
        console.log(response)
        if (response.data.data) {
          this.projectList = response.data.data;
        } else {
          this.projectList = []
        }
        console.log(1)
        console.log(this.projectList)

      })
    },
    //以下为:新建项目功能需要
    //获取矢量库
    getVectorLibrary: function () {
      let that = this
      let param = new FormData();
      param.append('pageNum', 1);
      param.append('pageSize', 1000);

      this.axios
          .post("/map_service_back/vectorLibrary/getVectorLibrary", param, {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('获取我的矢量库列表')

        if (response.data) {
          this.vectorList = response.data.data;
        }
        console.log(this.vectorList)
      })
    },
    //获取我的套件库
    queryRepositoryTkList: function () {
      this.axios.post("/tilesapi/tiles/repository/queryUserRepositoryList", null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        console.log("获取套件列表")
        console.log(response)
        let tempArray=response.data.data;
        console.log("套件二维数组")
        console.log(tempArray)
        for(let i=0;i<tempArray.length;i++){
          for(let j=0;j<tempArray[i].mkList.length;j++){
            tempArray[i].mkList[j].id=tempArray[i].mkList[j].id+"_"+i;
          }
        }

        this.multipleTreeData = tempArray;

      })
    },
    getKey() {
      return localStorage.getItem("token");
    },
    goHomeList(){
      this.XTBZ_FullScreen=false
      this.XTBZ_Stey=1
    },
    clearAll() {
      this.$store.state.search.longitude = ''
      this.$store.state.search.latitude = ''
      this.$store.state.search.selectedRangeStore = {
        upload:'',
        china:'',
        world:'',
        point:'',
        draw:'',
        coordinatesArray:'',
        rectangle:'',
        circle:''
      }
    },
    checkAndShow(shape_id) {
      console.log(shape_id)
      let shape
      this.overlay=true

      let param=new FormData();
      param.append('id',shape_id)
      this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
          .then((response) => {
            shape = response.data.data.geojson

            this.clearAll()
            this.overviewGeo.geojson=JSON.parse(shape)
            this.overviewGeo.id=shape_id
            if (this.overviewGeo.geojson.coordinates.length > 10) {
              this.viewVectorModal = true;
              this.overlay=false

              this.$nextTick(() => {
                this.$refs.map.mapObject.fitBounds(L.geoJSON(this.overviewGeo.geojson).getBounds())
              })
              this.$message.error('暂不支持选择要素数量大于10的矢量创建项目');
              return
            }

            let param1=new FormData();
            // param.append('shape_id',shape_id);
            param1.append('geom',shape);
            this.axios
                .post("/map_service_back/program/geomAreaHandle", param1, {
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then(res => {
              this.overlay=false

              if (res.data.needToBuffer) {
                this.bufferGeo.geojson=JSON.parse(res.data.data.geojson)
                this.bufferGeo.area=res.data.data.area
              } else {
                this.bufferGeo.geojson=''
                this.bufferGeo.area=''
              }
              this.viewVectorModal = true;
              this.$nextTick(() => {
                this.$refs.map.mapObject.fitBounds(L.geoJSON(this.overviewGeo.geojson).getBounds())
              })
            })
          })

    },
    handleCheckboxChange:function(data){
      console.log(this.editTree)
      console.log('套件选择')
      this.editTree=data
      let treeData=data.treeData;
      console.log(treeData)
      let repositoryObj=[];
      this.addProjectData.repository={list:[]};
      //把选中的tk、mk以接口要求格式赋值给repositoryObj
      for(let i=0;i<treeData.length;i++){
        if(treeData[i].$checked||treeData[i].$indeterminate){
          console.log("》》》》》in if 1")
          if(treeData[i].mkList){
            let temp_mkList=treeData[i].mkList
            let mkList=[];
            for(let j=0;j<temp_mkList.length;j++){
              if(temp_mkList[j].$checked){
                mkList.push((temp_mkList[j].id).split("_")[0])
              }
            }
            repositoryObj.push({"id":treeData[i].id,"mk_ids":mkList})
          }
        }
      }
      console.log("检验MK")
      console.log(repositoryObj)
      if(repositoryObj.length>0){
        this.addProjectData.repository={"list":repositoryObj}
      }
      console.log("this.addProjectData")
      this.print(this.addProjectData.repository)
      this.print(this.addProjectData)
    },
    //点击选择项目
    clickProject: function (projectId, item) {
      this.projectAndTask.selectedProject=projectId;
      this.wyhc.programId=projectId;
      console.log(projectId,item)
    },
    //人员分配点击完成
    assignEmployeesComplete:function () {
      console.log("点击分配人员完成：")
      console.log(this.markerUserlist)
      console.log(this.shenheUserlist)
      if(this.markerUserlist.length==0){
        this.$message.error("外业核查创建后无法修改，请先分配标注人员");
        return;
      }
      if(this.shenheUserlist.length==0){
        this.$message.error("外业核查创建后无法修改，请先分配审核人员");
        return;
      }
      this.wyhc.checkJl1UserIdList=[]
      this.wyhc.verifyJl1UserIdList=[]
      for(let i in this.markerUserlist){
        this.wyhc.checkJl1UserIdList.push(this.markerUserlist[i].jl1Account)
      }
      for(let j in this.shenheUserlist){
        this.wyhc.verifyJl1UserIdList.push(this.shenheUserlist[j].jl1Account)
      }
      let param=new FormData();
      param.append('name',this.wyhc.name);
      param.append('desp',this.wyhc.desp);
      param.append('checkJl1UserIdList',this.wyhc.checkJl1UserIdList);
      param.append('verifyJl1UserIdList',this.wyhc.verifyJl1UserIdList);
      param.append('programId',this.wyhc.programId);
      param.append('importShapeFile',this.wyhc.importShapeFile);

      this.axios.post("/tilesapi/tiles/task/field/task/importShapeFile",param,{
        headers:{
          Authorization:'Bearer ' + this.getKey(),
        }
      }).then((response)=>{
        console.log(response)
        if(response.data.code=="200"){
          this.step=5;
        }else if(response.data.code=="500") {
          alert(response.data.msg+",请重新上传zip文件")
          this.step=3;
        }



      })

    }
  },
  computed:{
    markerUserlist:function () {
      return this.$refs.markerModalForm.markerData;
    },
    shenheUserlist:function () {
      return this.$refs.shenheModalForm.markerData;
    }
  },
  mounted(){

    this.getMyProjectList();
    this.getVectorLibrary();
    this.getTeamList();
    this.queryRepositoryTkList();
    let array = [
      {
        id: '01',
        name: '广东省',
        children: [
          {
            fullPath: '0101',
            name: '广州市',
          },
          {
            fullPath: '0102',
            name: '深圳市',
          },
        ],
      }]
    this.repositoryMultipleTreeData = [array]
    this.getTeamList();


    bus.$off('update')
    bus.$on('update', (projectId) => {
      this.clickProject(projectId)

    })
  }
}

</script>
<style scoped lang="scss">
::v-deep .ant-upload-list-item{
  margin-top: -1px;
}
.rw_line{
  display: flex;
  justify-content: flex-start;
  min-height: 40px;
  height: auto;
  width: 98%;
  line-height: 40px;
  .rw_txt{
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  .rw_input{
    width: 1100px;
    height:auto;
    min-height: 40px;
  }
  .downloadButton{
    width: 146px;
    height: 26px;
    line-height: 26px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #0066CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #0066CC;
    text-align: center;
    cursor:pointer;
  }
}
.shareListCtn {
  width: 620px;
  height: auto;
  min-height: 60px;
  max-height: 420px;
  overflow-y: auto;
  font-size: 18px;
  padding-left: 20px;
  word-break: break-all;
}

.shareListCtn::-webkit-scrollbar {
  width: 4px;
}

.shareListCtn::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.shareListCtn::-webkit-scrollbar-track {
}
.topCtn-team {
  position: relative;
  margin-top: 6px;
  width: 220px;
  height: 189px;
  border-radius: 16px;
  border: 1px solid #979797;
  background-image: url("~@/assets/userCenter/我的团队-背景图.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  .contentMask {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    top: 0px;
    left: 0px;
    .contentItem {
      width: 100%;
      height: 20px;
      line-height: 20px;
      padding-left: 15px;
      padding-right: 10px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
.topCtn-team:hover .contentMask {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
}
.bottomCtn{
  display: flex;
  justify-content: center;
  width: 800px;
  height:50px;
  margin-left:auto;
  margin-right: auto;
  margin-top: 30px;
  padding-left: 30px;
  .btn_gray{
    width: 150px;
    height: 44px;
    background: rgba(0,0,0,0.2);
    border-radius: 8px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    cursor:pointer;
  }
  .btn_blue{
    width: 150px;
    height: 44px;
    border-radius: 8px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    border: 1px solid #006699;
    color: #006699;
    cursor:pointer;
  }
}
.selectedProject{
  border:solid 2px #006699 !important;
  background: #e6f7ff;
}
.mainBody{
  width: 100%;
  height:100%;
  background-image: url('../../assets/rsTool/选角色背景.png');
  background-size: 100% 100%;
  padding-top: 1px;
}
.mainCtn{
  width: 1720px;
  height:780px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 138px;
  .topCtn{
    display: flex;
    justify-content: space-between;
    width:100%;
    height:50px;
    .label{
      width: 188px;
      height: 40px;
      background: rgba(0,102,204,0.35);
      border-radius: 4px;
      line-height: 40px;
      font-size: 21px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #0066CC;
      padding-left: 6px;
    }
    .progressAxis{
      width: 683px;
      height:50px;
      margin-right: 50px;
      .dot{
        position:relative;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background: #CCCCCC;
        color:#979797;
        float:left;
      }
      .dotBlue{
        position:relative;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background: #006699;
        color:#006699;
        float:left;
      }
      .line{
        width: 200px;
        height: 2px;
        background: #CCCCCC;
        border-radius: 3px;
        float:left;
        margin-top: 4px;
      }
      .lineBlue{
        width: 200px;
        height: 2px;
        background: #006699;
        border-radius: 3px;
        float:left;
        margin-top: 4px;
      }
      .txt{
        position:absolute;
        bottom:-25px;
        left:-45px;
        width: 100px;
        height:20px;
        line-height: 20px;
        text-align: center;
        font-size: 16px;
      }
    }
  }


}
.signUp_content {
  margin-left: 230px;
  margin-top: 30px;
  width: 1350px;
  height: 560px;
  overflow-y: auto;
  overflow-x:hidden;
  .txt2{
    width: 262px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 25px;
    text-align: center;
  }
  .btn2{
    width: 150px;
    height: 44px;
    background: #006699;
    border-radius: 8px;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    cursor:pointer;
  }
  .assignEmployeesCtn{
    width: 1350px;
    height:320px;
  }
  .componentCtn-main {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 555px;
    display: flex;
    justify-content: left;
    flex-flow: wrap;
  }
  .componentCtn-main2 {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 530px;
    display: flex;
    justify-content: center;
    align-items: center;
    .tipCtn{
      width:1300px;
      height:500px;
      border-radius: 20px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .tip1{
        width: 100%;
        height:20px;
        text-align: center;
        font-size: 18px;
        color: #313131;
        font-weight: 600;
        margin-top: 40px;
      }
      .tip2{
        width: 100%;
        height:20px;
        text-align: center;
        font-size: 16px;
        color: #8d8d8d;
        margin-top: 50px;
      }
    }
  }

  .componentCtn-main-fullScreen {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100%;
    z-index: 10000;
  }
}
.createProjectLine {
  display: flex;
  justify-content: left;
  width: 100%;
  height: auto;
  min-height: 40px;
  margin-bottom: 20px;

  .item-name {
    position: relative;
    width: 90px;
    height: 40px;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .item-input {
    width: 560px;
    min-height: 40px;
    height: auto;
    .edit-tj-ctn{
      width: 100%;
      min-height: 100px;
      height:auto;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      .item-ctn{
        width:100%;
        height:auto;
        padding:0px 10px 5px 10px;
        .tj-title{
          height:35px;
          line-height: 35px;
          font-size: 16px;
          width: auto;
        }
        .mk-ctn{
          width: 100%;
          min-height: 30px;
          line-height: 30px;
          border:dashed 1px #d0d0d0;
          padding: 3px;
          display: flex;
          justify-content: left;
          flex-wrap:wrap;
          .mk-item{
            height:24px;
            line-height: 24px;
            text-align: center;
            padding-left:3px;
            padding-right:3px;
            border-radius: 5px;
            border:solid 1px #75adee;
            font-size: 14px;
            min-width: 40px;
            width:auto;
            margin-right: 10px;
            margin-bottom:5px;
            margin-top:5px;
          }
        }
      }
    }
  }
}
.vectorPanel {
  width: 100%;
  height: 200px;
  //border: solid 1px #f56300;
  overflow-y: scroll;

  .itemCtn {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    border-bottom: 1px solid #D8D8D8;;
  }
}

/*滚动条样式*/
.signUp_content::-webkit-scrollbar {
  width: 4px;
}

.signUp_content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.signUp_content::-webkit-scrollbar-track {
}
.projectCtn {
  width: 232px;
  height: 228px;
  border-radius: 16px;
  border: 1px solid #979797;
  margin-right: 32px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .topCtn {
    position: relative;
    margin-top: 6px;
    width: 220px;
    height: 189px;
    border-radius: 16px;
    border: 1px solid #979797;
    background-image: url("~@/assets/userCenter/我的项目背景图.png");
    background-repeat: no-repeat;
    cursor: pointer;

    .contentMask {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 16px;
      top: 0px;
      left: 0px;
      z-index:1000;

      .contentItem {
        width: 100%;
        height: 20px;
        line-height: 20px;
        padding-left: 15px;
        padding-right: 10px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
  ::v-deep.ant-btn-primary-disabled, .ant-btn-primary.disabled, .ant-btn-primary[disabled], .ant-btn-primary-disabled:hover, .ant-btn-primary.disabled:hover, .ant-btn-primary[disabled]:hover, .ant-btn-primary-disabled:focus, .ant-btn-primary.disabled:focus, .ant-btn-primary[disabled]:focus, .ant-btn-primary-disabled:active, .ant-btn-primary.disabled:active, .ant-btn-primary[disabled]:active, .ant-btn-primary-disabled.active, .ant-btn-primary.disabled.active, .ant-btn-primary[disabled].active {
    color: rgba(0, 0, 0, 1);
  }
  .topCtn:hover .contentMask {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: rgba(0, 0, 0, 0.6);
  }

  .middleCtn {
    width: 213px;
    height: 32px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1E81EB;
    line-height: 32px;
    text-align: center;
    background: linear-gradient(108deg, #1E81EB 0%, #AE48FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .bottomCtn {
    width: 100%;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;

    .bottomImg {
      display: block;
      margin-right: 16px;
      cursor: pointer;
    }
  }
}
/*滚动条样式*/
.vectorPanel::-webkit-scrollbar {
  width: 4px;
}

.vectorPanel::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.vectorPanel::-webkit-scrollbar-track {
}
.overviewVectorDiv{
  width: 660px;
  height: 570px;
  margin-left: -24px;
  margin-top: -24px;
  margin-bottom: -24px;
  // border:solid 1px #FF0000;
}
::v-deep .ant-modal-close{
  z-index: 410;
}




::v-deep .mapDialog{
  overflow-y: unset;
  z-index: 1001;
}
::v-deep .theme--light.v-card{
  background: rgba(238,238,238);
}

.mapdiv{
  position: absolute;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  left: 5px;
  top: 5px;
}
::v-deep .v-dialog:not(.v-dialog--fullscreen){
  max-height: unset;
}
::v-deep .v-dialog__content,
::v-deep.v-dialog__content--active{
  z-index: 1001 !important;
}
</style>